// Generated by tools/art/build.py — do not edit.
//
// Every scene a story may name ([Stories](../../../docs/STORIES.md)).
// The drawings are in `@capytalk/tokens`; these are the ids, so the
// content lint can refuse a `sceneRef` that points at nothing without
// the linter depending on the design tokens.
export const SCENE_REFS = [
    'art.scene.home',
    'art.scene.kitchen',
    'art.scene.bedroom',
    'art.scene.school',
    'art.scene.playground',
    'art.scene.park',
    'art.scene.shop',
    'art.scene.cafe',
    'art.scene.street',
    'art.scene.station',
    'art.scene.beach',
    'art.scene.surgery',
];
export const SCENE_LABELS = {
    'art.scene.home': [
        { lexemeId: 'en.lex.window', hitbox: [4, 20, 44, 34] },
        { lexemeId: 'en.lex.door', hitbox: [276, 38, 30, 50] },
        { lexemeId: 'en.lex.table', hitbox: [123, 60, 56, 28] },
        { lexemeId: 'en.lex.chair', hitbox: [178, 54, 24, 34] },
    ],
    'art.scene.kitchen': [
        { lexemeId: 'en.lex.oven', hitbox: [126, 54, 48, 34] },
        { lexemeId: 'en.lex.cup', hitbox: [189, 51, 25, 20] },
        { lexemeId: 'en.lex.window', hitbox: [252, 18, 52, 34] },
    ],
    'art.scene.bedroom': [
        { lexemeId: 'en.lex.window', hitbox: [4, 20, 44, 34] },
        { lexemeId: 'en.lex.bed', hitbox: [116, 48, 76, 40] },
    ],
    'art.scene.school': [
        { lexemeId: 'en.lex.table', hitbox: [119, 60, 64, 28] },
        { lexemeId: 'en.lex.chair', hitbox: [188, 54, 24, 34] },
    ],
    'art.scene.playground': [
        { lexemeId: 'en.lex.sun', hitbox: [143, 5, 34, 34] },
        { lexemeId: 'en.lex.cloud', hitbox: [28, 0, 59, 38] },
        { lexemeId: 'en.lex.slide', hitbox: [116, 38, 69, 50] },
        { lexemeId: 'en.lex.tree', hitbox: [266, 12, 52, 76] },
    ],
    'art.scene.park': [{ lexemeId: 'en.lex.cloud', hitbox: [156, 0, 67, 38] }],
    'art.scene.shop': [{ lexemeId: 'en.lex.cup', hitbox: [137, 51, 25, 20] }],
    'art.scene.cafe': [
        { lexemeId: 'en.lex.window', hitbox: [2, 18, 48, 36] },
        { lexemeId: 'en.lex.cup', hitbox: [143, 49, 25, 20] },
    ],
    'art.scene.street': [{ lexemeId: 'en.lex.cloud', hitbox: [182, 0, 59, 34] }],
    'art.scene.station': [
        { lexemeId: 'en.lex.train', hitbox: [106, 46, 108, 48] },
        { lexemeId: 'en.lex.cloud', hitbox: [195, 0, 50, 31] },
    ],
    'art.scene.beach': [
        { lexemeId: 'en.lex.sun', hitbox: [143, 7, 34, 34] },
        { lexemeId: 'en.lex.sea', hitbox: [0, 62, 320, 26] },
        { lexemeId: 'en.lex.umbrella', hitbox: [258, 16, 62, 72] },
    ],
    'art.scene.surgery': [{ lexemeId: 'en.lex.bed', hitbox: [116, 48, 84, 40] }],
};
//# sourceMappingURL=scenes.generated.js.map